import { call, get } from 'vuex-pathify';
export default {
  computed: {
    historyDeletedValue: get('admin/modulesMapping@history.change_type.deleted'),
    restoreHistoryFeatureButton() {
      return this.isHistoryLayer
        ? [
            {
              name: 'restoreHistoryFeature',
              icon: 'mdi-restore',
              tooltip:
                this.currentLayerSelectedFeatures?.length !== 1
                  ? this.$i18n.t('button.selectObjectToRestore')
                  : this.selectedHistoryFeatureData.type !== this.historyDeletedValue
                  ? this.$i18n.t('button.selectOnlyDeleted')
                  : this.$i18n.t('button.restoreHistoryFeature'),
              fontSize: '20px',
              disabled:
                this.currentLayerSelectedFeatures?.length !== 1 ||
                this.selectedHistoryFeatureData.type !== this.historyDeletedValue,
            },
          ]
        : [];
    },
    historyMetadata: get('admin/modulesMapping@history'),
    isHistoryLayer() {
      return this.layerId === this.historyMetadata?.history_layer_id;
    },
  },
  data: () => ({
    isRestoreFeatureDialogOpen: false,
    isRestoreFeatureDialogLoaded: false,
    isRestoreFeatureDialogLoading: false,
    selectedHistoryFeatureData: {
      type: undefined,
      layerId: undefined,
    },
  }),
  methods: {
    restoreHistory: call('changeHistory/restoreHistory'),
    restoreHistoryFeatureAction() {
      this.isRestoreFeatureDialogOpen = true;
      this.isRestoreFeatureDialogLoaded = true;
    },
    async restoreFeature() {
      this.isRestoreFeatureDialogLoading = true;
      try {
        await this.restoreHistory({
          id: this.currentLayerSelectedFeatures[0],
          params: {
            ...(this.selectedHistoryFeatureData.layerId ? { layer_id: this.selectedHistoryFeatureData.layerId } : {}),
          },
        });
        this.$root.$emit('refreshTableData');
        if (this.selectedHistoryFeatureData.layerId) {
          this.$root.$emit('updateLegendStylesCounts', { layersIds: [this.selectedHistoryFeatureData.layerId] });
          this.$root.$emit('refreshMvtSource', this.selectedHistoryFeatureData.layerId);
        }
        this.isRestoreFeatureDialogLoading = false;
        this.isRestoreFeatureDialogOpen = false;
      } catch {
        this.isRestoreFeatureDialogLoading = false;
      }
    },
  },
};
